<form class="k-form k-form-md" [formGroup]="appBasicData">
    <div class="row">
        <div class="col-sm-6 col-md-6 col-lg-3">
            <kendo-formfield>
                <kendo-label [for]="RequiredDate" [optional]="true" [text]="'requested_by' | translate"></kendo-label>
                <kendo-datepicker id="requestedBy" #RequiredDate formControlName="requiredDate"
                    [min]="min"></kendo-datepicker>
                <kendo-formhint style="color:darkcyan;">{{'date_request_to_be_ordered' |
                    translate}}</kendo-formhint>
            </kendo-formfield>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-5">
            <kendo-formfield>
                <kendo-label [for]="subApplication" [text]="'subapplication' | translate"></kendo-label>
                <kendo-dropdownlist formControlName="applicationId" [data]="subApplicationsFiltered"
                    #subApplication textField="name" [valuePrimitive]="true" valueField="value"
                    [showStickyHeader]="true" groupField="subcategory" required="true"
                    adaptiveMode="auto" [filterable]="true" (filterChange)="onSubApplicationFilter($event)">
                    <ng-template kendoDropDownListGroupTemplate let-groupName>
                        <strong style="font-weight: 900; font-size: large;">{{ groupName }}</strong>
                    </ng-template>
                </kendo-dropdownlist>
                <kendo-formhint style="color:darkcyan;">{{'select_sub-application' | translate}}</kendo-formhint>
                <kendo-formerror>{{'error_sub-ppplication' | translate}}</kendo-formerror>
            </kendo-formfield>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-4">
            <kendo-formfield>
                <kendo-label [for]="productLine" [text]="'subpsl_productline' | translate"></kendo-label>
                <kendo-dropdownlist formControlName="productLine" #productLine
                    [data]="productLinesFiltered" textField="name" [valuePrimitive]="true"
                    valueField="value" (valueChange)="handleProductlineChange($event)" adaptiveMode="auto"
                    [filterable]="true" (filterChange)="onProductLineFilter($event)">
                    <ng-template kendoDropDownListGroupTemplate let-groupName>
                        <strong style="font-weight: 900; font-size: large;">{{ groupName }}</strong>
                    </ng-template>
                </kendo-dropdownlist>
                <kendo-formhint style="color:darkcyan;">{{'select_productline' | translate}}</kendo-formhint>
                <kendo-formerror>{{'error_productline' | translate}}</kendo-formerror>
            </kendo-formfield>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-3" *ngIf="false">
            <kendo-formfield>
                <kendo-label [for]="region" text="Region"></kendo-label>
                <kendo-dropdownlist formControlName="nwA_ApplicationId" #region textField="text" [valuePrimitive]="true"
                    valueField="value" [data]="regionOptions" required="true" adaptiveMode="auto"></kendo-dropdownlist>
                <kendo-formhint style="color:darkcyan;">{{'select_region' | translate}}</kendo-formhint>
                <kendo-formerror>{{'error_region' | translate}}</kendo-formerror>
            </kendo-formfield>
        </div>
    </div>
    <div class="row">
        
        <div class="col-sm-6 col-md-6 col-lg-3">
            <kendo-formfield>
                <kendo-label [for]="priorityLevel" [text]="'priority_level' | translate"></kendo-label>
                <kendo-dropdownlist formControlName="priority" #priorityLevel [data]="priorityOptions$ | async"
                    textField="name" [valuePrimitive]="true" valueField="value"
                    adaptiveMode="auto"></kendo-dropdownlist>
                <kendo-formhint style="color:darkcyan;">{{'urgency_rta' | translate}}</kendo-formhint>
            </kendo-formfield>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-3">
            <kendo-formfield>
                <kendo-label [for]="designReference" [text]="'design_reference' | translate"></kendo-label>
                <kendo-textbox formControlName="Reference" #designReference>
                    <ng-template kendoTextBoxSuffixTemplate>
                        <button type="button" class="import-reference-btn" (click)="importReference()"
                            [disabled]="readonly || isImporting"
                            title="Import reference data, this will overwrite current reference fields and can't be undone" aria-label="Import reference data, this will overwrite current reference fields and can't be undone">
                            <kendo-svgicon [icon]="importIcon" size="small"></kendo-svgicon>
                        </button>
                        <kendo-svgicon [icon]="eyeIcon" [title]="'review_reference' | translate" (click)="openRefmatnum()" style="cursor: pointer;"></kendo-svgicon>
                        <kendo-svgicon [icon]="handIcon" [title]="'maintain_material' | translate"></kendo-svgicon>
                    </ng-template>
                </kendo-textbox>
                <kendo-formhint style="color:darkcyan;">{{'design_used' | translate}}</kendo-formhint>
                <kendo-formhint *ngIf="referenceLocked" style="color: #e65100; font-weight: 500;">
                    <span class="k-icon k-font-icon k-i-warning" style="margin-right: 4px;"></span>
                    This part is currently checked out for revision. Using it may cause delays.
                </kendo-formhint>
            </kendo-formfield>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-3">
            <kendo-formfield>
                <kendo-label [for]="excluded" [text]="'excluded' | translate"></kendo-label>
                <kendo-dropdownlist formControlName="requestExclusion" #excluded [data]="yesno" textField="name"
                    [valuePrimitive]="true" valueField="value" adaptiveMode="auto"></kendo-dropdownlist>
                <kendo-formhint *ngIf="appBasicData.value.Excluded" style="color:darkcyan;">{{'excluding_notice' |
                    translate}}</kendo-formhint>
            </kendo-formfield>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-3">
            <kendo-formfield>
                <kendo-label [for]="targetCustomer" [text]="'target_customer' | translate"
                    [optional]="true"></kendo-label>
                <kendo-textbox formControlName="targetCustomer" #targetCustomer></kendo-textbox>
            </kendo-formfield>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-8 col-md-6">
            <kendo-formfield>
                <kendo-label [for]="activeChallenges" [text]="'active_challenges' | translate"
                    [optional]="true"></kendo-label>
                <kendo-multiselect formControlName="activeProblems" #activeChallenges
                    [data]="(activeProblemOptions$ | async) ?? []" valueField="id" textField="name"></kendo-multiselect>
            </kendo-formfield>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-4">
            <kendo-formfield>
                <kendo-label [for]="customerRequirements" [text]="'customer_requirements' | translate"
                    [optional]="true"></kendo-label>
                <kendo-multiselect formControlName="customerRequirements" #customerRequirements
                    [data]="init_CustomerRequirements" [allowCustom]="true" [valuePrimitive]="true"></kendo-multiselect>
            </kendo-formfield>
        </div>
    </div>
    <span class="k-form-separator" style="padding-top: 10px;"></span>
    <div class="row">
        <div class="col-lg-12">
            <kendo-formfield>
                <kendo-label [for]="notesToDesignSupport" [text]="'notes_to_design' | translate"></kendo-label>
                <kendo-editor formControlName="notesToDesignSupport" [iframe]="false" #notesToDesignSupport
                    style="height: 150px;"></kendo-editor>
                <kendo-formhint style="color:darkcyan;">{{'notes_to_design_message' | translate}}</kendo-formhint>
            </kendo-formfield>
        </div>
        <div class="col-lg-12">
            <kendo-formfield>
                <kendo-label [for]="description" [text]="'description' | translate"></kendo-label>
                <kendo-editor formControlName="description" #description style="height: 150px;"
                    [iframe]="false"></kendo-editor>
                <kendo-formhint style="color:darkcyan;">{{'description_message' | translate}}</kendo-formhint>
            </kendo-formfield>
        </div>
        <div class="col-lg-12">
            <kendo-formfield>
                <kendo-label [for]="differencesfromReference" text="Differences from Reference"
                    [text]="'differences_from_reference' | translate"></kendo-label>
                <kendo-textbox formControlName="difference" #differencesfromReference></kendo-textbox>
                <kendo-formhint style="color:darkcyan;">{{'differences_from_reference_message' |
                    translate}}</kendo-formhint>
            </kendo-formfield>
        </div>
    </div>
</form>